<rt-assistant-list-card [linkTarget]="linkTarget()" [label]="data().name">
  <rt-list-row-person class="person" [data]="data()">
    @if (data().badge; as badge) {
      @if (badge.kind === 'overdue') {
        <rt-badge
          slot="title-badge"
          color="overdue"
          [text]="'app.overdue_candidates.badge' | translate: { days: badge.days }"
        />
      }
    }
  </rt-list-row-person>
</rt-assistant-list-card>
